/**
 * @file vertical-tabs
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakVerticalTabs = {
    attach: function (context, settings) {
      once('paragraph--tabs-block', '.paragraph--type--vertical-tabs-block, .paragraph--type--horizontal-tabs-block', context).forEach(function (element) {
      $(".tabs-container").each(function () {
        $(this)
          .find(".tab")
          .click(function (e) {
            e.preventDefault();
            const targetId = $(this).attr("data-target");
            $(this)
              .parents(".tabs-container")
              .find(".tab")
              .removeClass("active");
            $(this)
              .parents(".tabs-container")
              .find(".content")
              .removeClass("active");
            $(this)
              .parents(".tabs-container")
              .find(".tab-heading-mobile")
              .removeClass("active");

            $(this).addClass("active");
            $(".tab-heading-mobile[data-target=" + targetId + "]").addClass(
              "active"
            );
            $("#" + targetId).addClass("active");
            return false;
          });
      });

      $(".tabs-container").each(function () {
        $(this)
          .find(".tab-heading-mobile")
          .click(function (e) {
            e.preventDefault();
            const targetId = $(this).attr("data-target");

            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(".tab-li .tab[data-target=" + targetId + "]").removeClass(
                "active"
              );
              $("#" + targetId).removeClass("active");
            } else {
              $(this)
                .parents(".tabs-container")
                .find(".tab")
                .removeClass("active");
              $(this)
                .parents(".tabs-container")
                .find(".content")
                .removeClass("active");
              $(this)
                .parents(".tabs-container")
                .find(".tab-heading-mobile")
                .removeClass("active");

              $(this).addClass("active");
              $(".tab-li .tab[data-target=" + targetId + "]").addClass(
                "active"
              );
              $("#" + targetId).addClass("active");
              $('html, body').animate({
                scrollTop: $(this).offset().top - 180
              }, 10);
            }

            return false;
          });
      });

      // Check the first tab always open.
      $(window).resize(function(){
        $(".tabs-container").each(function () {
          if ($(this).find(".tab").hasClass('active')) {
          }else {
            if ($(window).width() >= 700) {
              $(this).find(".tab-li:first-child .tab").addClass('active');
              const targetId = $(this).find(".tab-li:first-child .tab").attr("data-target");
              $("#" + targetId).addClass("active");
              $(".tab-heading-mobile[data-target=" + targetId + "]").addClass(
                "active"
              );
            }
          }
        });
      });
    });
    },
  };
})(jQuery, Drupal, once);
